// Dependencies
import React from 'react';
import { useTranslation } from 'react-i18next';

// Styles
import { ContainerSimpleBg, InputSimpleBg, SwitchSimpleBg } from './styles';

// Components
import { Typography } from '../../../../display/Typography';

// Types
import { SwitchSimpleBackgroundTypes } from './types';

const SimpleBackgroundSwitch = ({
  changeState,
  state,
  disabled,
}: SwitchSimpleBackgroundTypes) => {
  const { t } = useTranslation('common');
  const handleClick = () => {
    changeState(!state);
  };

  return (
    <ContainerSimpleBg activate={state}>
      <SwitchSimpleBg defaultChecked={state}>
        <InputSimpleBg
          type="checkbox"
          checked={state}
          onChange={handleClick}
          disabled={disabled}
        />
      </SwitchSimpleBg>
      <Typography size="XS">
        {state ? t('switches.yesThereIs') : t('switches.noThereIs')}
      </Typography>
    </ContainerSimpleBg>
  );
};

export default SimpleBackgroundSwitch;
